import { render, staticRenderFns } from "./iqalacomments.vue?vue&type=template&id=98c6f0d4&"
import script from "./iqalacomments.vue?vue&type=script&lang=js&"
export * from "./iqalacomments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports